import React from 'react';
import { Route, Redirect } from 'react-router';
import { selectLoggedIn } from '../state';
import { useSelector } from 'react-redux';

export function LoggedOutRoute({ component: Component, ...rest }: any) {
  const loggedIn = useSelector(selectLoggedIn);
  if (loggedIn === undefined) {
    return (
      <div>
        Loading...
      </div>
    )
  }
  return (
    <Route {...rest} render={(props) => (
      !loggedIn
        ? <Component {...props} />
        : <Redirect to='/' />
    )} />
  );
}